/**
 * ⭐ **ICE SUNUCULARI — katılım yanıtından odaya taşınır.**
 *
 * ════════════════════════════════════════════════════════════════════════
 * 🚨 ÇÖZDÜĞÜ HATA: TURN İSTEMCİYE HİÇ ULAŞMIYORDU
 * ════════════════════════════════════════════════════════════════════════
 * Sunucu `POST …/join` yanıtında `iceServers` üretiyordu. İstemci o alanı
 * **hiç okumuyordu**: `JoinResponse` arayüzünde alan yoktu ve
 * `WorkerSfuTransport` dördüncü argümanı olmadan kuruluyordu. Sonuç:
 * `transport.iceServers()` **her zaman `[]`** döndürüyor ve üç
 * `RTCPeerConnection` de STUN/TURN'süz kuruluyordu.
 *
 * Kullanıcıya etkisi: simetrik NAT veya kurumsal güvenlik duvarı arkasındaki
 * herkes için medya **hiç kurulmaz** — "katıldım ama kimseyi göremiyorum",
 * üstelik hata mesajı da yok. Hedef kitlemiz tam da o ağlar (Rapor 01 §9.1).
 *
 * Dahası, `reconnectViaRelay()` kurtarma adımı `iceTransportPolicy: "relay"`
 * kullanıyor: sıfır TURN + relay zorlaması = **sıfır aday**. Yani kurtarma
 * merdiveninin ikinci basamağı yapısal olarak imkânsızdı.
 *
 * ⚠️ **Depolamaya YAZILMAZ.** TURN kimlik bilgileri kısa ömürlü sırlardır;
 *    `sessionStorage`/`localStorage`'a yazmak onları XSS'e ve sekme
 *    geçmişine açardı. Erişim jetonuyla aynı kural: yalnız bellek.
 *
 * ⚠️ Modül seviyesinde tutulur çünkü katılım sayfası ile oda **ayrı
 *    bileşenlerdir** ama artık aynı sayfa yüklemesindedir
 *    (`app/navigate.ts`). Tam sayfa yüklemesi olsaydı bu da kaybolurdu —
 *    nitekim erişim jetonu için yaşanan sorun buydu.
 */

let iceServers: RTCIceServer[] = [];

/**
 * ⚠️ Gelen değer **doğrulanır**: sunucu sözleşmesi değişirse veya alan hiç
 *    gelmezse, tanımsız bir değeri `RTCPeerConnection`'a vermek yapılandırma
 *    hatasıyla bağlantıyı tümden engellerdi. Geçersizse boş liste kalır ve
 *    bağlantı en azından host adaylarıyla denenir.
 */
export function setIceServers(raw: unknown): void {
  if (!Array.isArray(raw)) return;
  iceServers = raw.filter((s): s is RTCIceServer => {
    if (typeof s !== "object" || s === null) return false;
    const urls = (s as { urls?: unknown }).urls;
    return typeof urls === "string" || Array.isArray(urls);
  });
}

export function getIceServers(): RTCIceServer[] {
  return iceServers;
}

/** ⚠️ TURN yokluğu **sessiz kalmamalı**: relay kurtarması buna bakar. */
export function hasTurn(): boolean {
  return iceServers.some((s) => {
    const urls = Array.isArray(s.urls) ? s.urls : [s.urls];
    return urls.some((u) => typeof u === "string" && u.startsWith("turn"));
  });
}
